export const setQuestionCardOfflineTexts = (question) => ({
  text: question.alternative_texts ? question.alternative_texts[0]?.text : '',
});
